import { palette } from '@livable/saas-react-components';
const MuiFormControlLabel = {
  styleOverrides: {
    root: {
      marginLeft: '-10px',
      marginRight: '0',
      width: 'fit-content'
    },
    label: {
      marginRight: '20px',
      fontSize: '18px',
      '&.Mui-disabled': {
        color: palette.shades[800]
      }
    }
  }
};
export default MuiFormControlLabel;